// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentsPage_wrapper__QaO+a","mainContainer":"DocumentsPage_mainContainer__stKXm"};